@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.location

import com.narbase.letsgo.router.EndPoint

object LogPassengerLocationEndpoint : EndPoint<LogPassengerLocationEndpoint.Request, LogPassengerLocationEndpoint.Response>() {
    class Request(
        val lat: Double,
        val lng: Double,
    )

    class Response
}